module.exports = __webpack_public_path__ + "img/account_bg.2cab64a9.png";